"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreadTypeEnum = void 0;
/** Типы нитей */
var ThreadTypeEnum;
(function (ThreadTypeEnum) {
  /** 1:1 */
  ThreadTypeEnum[ThreadTypeEnum["private"] = 1] = "private";
  /** Группа */
  ThreadTypeEnum[ThreadTypeEnum["group"] = 2] = "group";
  /** Комментарии к контенту */
  ThreadTypeEnum[ThreadTypeEnum["content"] = 3] = "content";
  /** Комментарии к классам (митингам) */
  ThreadTypeEnum[ThreadTypeEnum["meeting"] = 4] = "meeting";
  /** Комментарии 1:1 внутри митинга */
  ThreadTypeEnum[ThreadTypeEnum["meeting_private"] = 5] = "meeting_private";
})(ThreadTypeEnum = exports.ThreadTypeEnum || (exports.ThreadTypeEnum = {}));
